import Vue from 'vue/dist/vue.esm.js';

import Tooltip from 'elementui-lts/lib/tooltip';
import Popover from 'elementui-lts/lib/popover';
import Radio from 'elementui-lts/lib/radio';
import RadioButton from 'elementui-lts/lib/radio-button';
import RadioGroup from 'elementui-lts/lib/radio-group';
import Steps from 'elementui-lts/lib/steps';
import Step from 'elementui-lts/lib/step';
import Input from 'elementui-lts/lib/input';
import Checkbox from 'elementui-lts/lib/checkbox';
import Button from 'elementui-lts/lib/button';
import ButtonGroup from 'elementui-lts/lib/button-group';
import Badge from 'elementui-lts/lib/badge';
import Form from 'elementui-lts/lib/form';
import FormItem from 'elementui-lts/lib/form-item';
import Select from 'elementui-lts/lib/select';
import Option from 'elementui-lts/lib/option';
import DatePicker from 'elementui-lts/lib/date-picker';
import Switch from 'elementui-lts/lib/switch';
import Slider from 'elementui-lts/lib/slider';
import Tree from 'elementui-lts/lib/tree';
import Statistic from 'elementui-lts/lib/statistic';

import Container from 'elementui-lts/lib/container';
import Dialog from 'elementui-lts/lib/dialog';
import Row from 'elementui-lts/lib/row';
import Col from 'elementui-lts/lib/col';
import Link from 'elementui-lts/lib/link';
import Card from 'elementui-lts/lib/card';
import Dropdown from 'elementui-lts/lib/dropdown';
import Menu from 'elementui-lts/lib/menu';
import MenuItem from 'elementui-lts/lib/menu-item';
import MenuItemGroup from 'elementui-lts/lib/menu-item-group';
import DropdownMenu from 'elementui-lts/lib/dropdown-menu';
import DropdownItem from 'elementui-lts/lib/dropdown-item';
import Submenu from 'elementui-lts/lib/submenu';
import Collapse from 'elementui-lts/lib/collapse';
import CollapseItem from 'elementui-lts/lib/collapse-item';
import Upload from 'elementui-lts/lib/upload';

import breadcrumb from 'elementui-lts/lib/breadcrumb';
import breadcrumbItem from 'elementui-lts/lib/breadcrumb-item';
import Loading from 'elementui-lts/lib/loading';
import Notification from 'elementui-lts/lib/notification';
import MessageBox from 'elementui-lts/lib/message-box';
import Icon from 'elementui-lts/lib/icon';
import Tabs from 'elementui-lts/lib/tabs';
import TabPane from 'elementui-lts/lib/tab-pane';
import Tag from 'elementui-lts/lib/tag';
import Progress from 'elementui-lts/lib/progress';
import ColorPicker from 'elementui-lts/lib/color-picker';
import Alert from 'elementui-lts/lib/alert';

import {
    CheckboxGroup,
    InputNumber,
    Table,
    TableColumn,
    Carousel,
    CarouselItem
} from 'elementui-lts';
import Pagination from 'elementui-lts/lib/pagination';
import PageHeader from 'elementui-lts/lib/page-header';
import Empty from 'elementui-lts/lib/empty';
import Drawer from 'elementui-lts/lib/drawer';
import DescriptionsItem from 'elementui-lts/lib/descriptions-item';
import Divider from 'elementui-lts/lib/divider';
import PopConfirm from 'elementui-lts/lib/popconfirm';
import Skeleton from 'elementui-lts/lib/skeleton';
import SkeletonItem from 'elementui-lts/lib/skeleton-item';

import Timeline from 'elementui-lts/lib/timeline';
import TimelineItem from 'elementui-lts/lib/timeline-item';
import Scrollbar from 'elementui-lts/lib/scrollbar';
import Descriptions from 'elementui-lts/lib/descriptions';

export default {
    config() {
        Vue.component(Tooltip.name, Tooltip);
        Vue.component(Popover.name, Popover);
        Vue.component(Radio.name, Radio);
        Vue.component(Skeleton.name, Skeleton);
        Vue.component(SkeletonItem.name, SkeletonItem);
        Vue.component(RadioButton.name, RadioButton);
        Vue.component(RadioGroup.name, RadioGroup);
        Vue.component(Steps.name, Steps);
        Vue.component(Step.name, Step);
        Vue.component(Input.name, Input);
        Vue.component(Checkbox.name, Checkbox);
        Vue.component(CheckboxGroup.name, CheckboxGroup);
        Vue.component(Button.name, Button);
        Vue.component(ButtonGroup.name, ButtonGroup);
        Vue.component(Badge.name, Badge);
        Vue.component(Form.name, Form);
        Vue.component(FormItem.name, FormItem);
        Vue.component(Select.name, Select);
        Vue.component(Option.name, Option);
        Vue.component(DatePicker.name, DatePicker);
        Vue.component(Switch.name, Switch);
        Vue.component(Statistic.name, Statistic);

        Vue.component(Container.name, Container);
        Vue.component(Dialog.name, Dialog);
        Vue.component(Row.name, Row);
        Vue.component(Col.name, Col);
        Vue.component(Link.name, Link);
        Vue.component(Card.name, Card);
        Vue.component(Dropdown.name, Dropdown);
        Vue.component(Menu.name, Menu);
        Vue.component(MenuItem.name, MenuItem);
        Vue.component(MenuItemGroup.name, MenuItemGroup);
        Vue.component(DropdownItem.name, DropdownItem);
        Vue.component(Submenu.name, Submenu);
        Vue.component(DropdownMenu.name, DropdownMenu);
        Vue.component(Tabs.name, Tabs);
        Vue.component(TabPane.name, TabPane);
        Vue.component(Tag.name, Tag);
        Vue.component(Table.name, Table);
        Vue.component(TableColumn.name, TableColumn);
        Vue.component(Pagination.name, Pagination);
        Vue.component(Collapse.name, Collapse);
        Vue.component(CollapseItem.name, CollapseItem);
        Vue.component(Upload.name, Upload);
        Vue.component(InputNumber.name, InputNumber);
        Vue.component(Drawer.name, Drawer);
        Vue.component(Carousel.name, Carousel);
        Vue.component(CarouselItem.name, CarouselItem);

        Vue.component(Divider.name, Divider);
        Vue.component(PopConfirm.name, PopConfirm);
        Vue.component(Slider.name, Slider);
        Vue.component(Tree.name, Tree);

        Vue.component(PageHeader.name, PageHeader);
        Vue.component(Descriptions.name, Descriptions);
        Vue.component(DescriptionsItem.name, DescriptionsItem);

        Vue.component(Empty.name, Empty);
        Vue.component(breadcrumb.name, breadcrumb);
        Vue.component(breadcrumbItem.name, breadcrumbItem);

        Vue.use(Loading.directive);
        Vue.use(Icon);
        Vue.use(Alert);
        Vue.component(Timeline.name, Timeline);
        Vue.component(TimelineItem.name, TimelineItem);
        Vue.component(Progress.name, Progress);
        Vue.component(ColorPicker.name, ColorPicker);
        Vue.prototype.$loading = Loading.service;
        Vue.prototype.$notify = Notification;
        Vue.prototype.$messageBox = MessageBox;
        Vue.component(Scrollbar.name, Scrollbar);
    }
};
